import { render, staticRenderFns } from "./employeeSalary.vue?vue&type=template&id=99e07626"
import script from "./employeeSalary.vue?vue&type=script&lang=js"
export * from "./employeeSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports